import {axiosNodeClient} from '../http';

export const nailMenuServiceNode = {
    get,
    create,
    update,
    del
}

function get(id) {
    if (id && id > 0) {
        return axiosNodeClient.get(`/nailmenu/${id}`);
    }
    else {
        return axiosNodeClient.get('/nailmenu');
    }
}

function create(nailMenu) {
    return axiosNodeClient.post('/nailmenu', nailMenu);
}

function update(nailMenu) {
    return axiosNodeClient.put(`/nailmenu/${nailMenu.id}`, nailMenu);
}

function del(id) {
    return axiosNodeClient.delete(`/nailmenu/${id}`);
}
